import { createAsyncThunk } from '@reduxjs/toolkit';
import { brandAPI } from './brandAPI';

export const fetchStats = createAsyncThunk('brand/fetchStats', async (queryParams) => {
  try {
    if (queryParams?.fromDate && queryParams?.toDate) {
      const response = await brandAPI.fetchStats(queryParams);
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
});

export const fetchBrandsLight = createAsyncThunk('brand/fetchBrandsLight', async (payload) => {
  const response = await brandAPI.fetchBrandsLight(payload);
  return response.data;
});
